<template>
	<div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 550px" class="yl-flex flex_between">
				<Input placeholder="搜索账户名称" v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
				<Button class='ivu-btn-circle' type="primary" @click="addAccountButton">添加账户</Button>
			</div>
		</div>
		<div class="multiple">
			<div class="child-div">创建时间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">账户状态</div>
			<RadioGroup v-model="account_status" @on-change="getList">
				<Radio label="1"><span>全部</span></Radio>
				<Radio label="2"><span>启用</span></Radio>
				<Radio label="3"><span>暂停</span></Radio>
			</RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">操作人</div>
			<Select v-model="uid" style="width: 200px;">
				<Option v-for="item in operaterList" :value="item.id" :key="item.id">
					{{item.username }}-[{{item.id}}]
				</Option>
			</Select>
		</div>
		<div style="width: 100% ;margin-top: 20px;">
			<Table stripe border :columns="columns" :data="datas" ref="table">
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
						@click="editAccount">编辑</Button>
					<Button type="error" size="small" :data-id="row.id" @click="delAccount">删除</Button>
				</template>
				<template slot-scope="{row, index}" slot="status" >
					<i-switch v-model="datas[index].status" @on-change="saveOpen($event, index)">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
			</Table>
			<div>
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
			</div>
		</div>
		<!--Modal v-model="CreateCostModal" width="1000" title="余额">
			<CreateCost></CreateCost>
		</Modal-->
		<!-- 提现申请 -->
		<Modal v-model="modal" width="500" title="编辑账户">
			<Form :label-width="120">
				<FormItem label="账户id">
					<Input placeholder="账户id" v-model="accountForm.account_id"></Input>
				</FormItem>
				<FormItem label="账户名称">
					<Input placeholder="账户名称" v-model="accountForm.account_name"></Input>
				</FormItem>
				<FormItem label="运营">
					<Select v-model="accountForm.uid">
						<Option v-for="item in operaterList" :value="item.id" :key="item.id">
							{{item.username }}-[{{item.id}}]
						</Option>
					</Select>
				</FormItem>
				<FormItem label="账户类型">
					<Select v-model="accountForm.cid_type"  placeholder="请选择媒体代码">
						<Option v-for="item in cidTypeList" :value="item.id"  :key="item.id">
							{{ item.type}}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="accountForm.status">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</FormItem>
				<FormItem label="备注">
					<Input placeholder="备注" v-model="accountForm.remark"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="accountEditSubmit">提交</Button>
				<Button type="default" @click="modal = false">取消</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
	import {
		mapGetters,
		mapMutations
	} from "vuex";
	import {
		getAllMediumCode,
		getAccountStatic,
		getAllAccountList,
		accountManage,
		getAccount,
		getAllOperater,
		getToutiaoSrc,
		addAccount,
		getCidTypeList,
		saveAccountStatusOpen,
		delAccount
	} from "../../api/advManage";
	import CreateCost from "./components/CreateCost.vue"; //排行榜

	export default {
		name: "AccountStatic",
		props: ['clickTabValue'],
		components: {
			CreateCost
		},
		data() {
			return {
				modal: false,
				name: '',
				timePeriod: '0',
				timePeriodDate: [],
				datas: [],
				operaterList:[],
				srcList:[],
				cidTypeList:[],
				uid:[],
				account_status:'2',
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 500],
				count: 0,
				accountForm: {
					account_id:'',
					uid:'',
					account_name:'',
					remark:'',
					account_src:[],
				},
				CreateCostModal: false,
				columns: [{
						"title": "序号",
						type: 'index',
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "账户名称",
						"key": "account_name",
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "账户id",
						"key": "account_id",
						"align": "center",
						"fixed": 'left'
					},
					{
						"title": "操作人",
						"key": "username",
						"align": "center",
						"sortable": true
					},
					{
						"title": "账户类型",
						"key": "type",
						"align": "center",
					},
					{
						"title": "状态",
						"slot": "status",
						"align": "center",
					},
					{
						"title": "媒体代码",
						"key": "account_src",
						"align": "center",
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		methods: {
			...mapMutations([
				'setaddSrcIdStatus',
			]),
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.account_status = '2';
				this.page = 1;
				this.pageSize = 10;
				this.timePeriod = 0;
				this.timePeriodDate = [];
				this.uid = [];
				this.search();
			},
			createCost() {
				this.CreateCostModal = true;
			},
			async loadData() {
				let that = this;
				 let data = {}
				 data.token = this.token;
				 let res = await getAllOperater(that, data);
				 that.operaterList = res.data.list;
				 res = await getToutiaoSrc(that, data);
				 that.srcList = res.data.list;
				 res = await getCidTypeList(that, data);
				 that.cidTypeList = res.data.list;
			},
			saveOpen(e, index) {
				console.log(e)
				let item = this.datas[index];
				let that = this;
				let data = {
					token: this.token,
					id: item.id,
					status: item.status
				};
				this.throttle(async function() {
					let res = await saveAccountStatusOpen(that, data);
					if (res.code == 1) {
						that.$Message.success('操作成功');
					}
				}, 200)
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await accountManage(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			// 编辑账户
			async editAccount(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
				};
				let res = await getAccount(that, data);
				console.log(res)
				if (res.code == 1) {
					that.accountForm = res.data.item;
					that.modal = true;
				}
			},
			// 删除账户
			delAccount(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delAccount(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			addAccountButton() {
				this.accountForm = {};
				this.modal = true;
			},
			async accountEditSubmit() {
				let that = this;
				let data = {
					token: that.token,
					accountForm: that.accountForm,
				};
				let res = await addAccount(that, data);
				if (res.code == 1) {
					this.modal = false;
					this.setaddSrcIdStatus(Date.parse(new Date()))
					this.getList();
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
